import CloseIcon from '@/assets/icons/x-icon-white.svg';
import { Chip as MuiChip, ChipProps } from '@mui/material';

interface IProps extends ChipProps {
    clearable?: boolean;
}

export const Chip = ({ clearable = false, color = 'primary', size = 'medium', ...props }: IProps) => {
    return <MuiChip color={color} size={size} {...props} deleteIcon={clearable ? <img src={CloseIcon}/> : <></>} />;
};

export default Chip;
